import { Component, Input, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MessageService } from 'primeng/api';
import { BuildType } from 'src/app/enums/build-type';
import { AssetTypes } from 'src/app/entities/enums/AssetTypes';
import { CommonEntityService } from 'src/app/common/services/common-entity.service';
import { BuildService } from 'src/app/build-data/services/build.service';

@Component({
    selector: 'app-misc-image-array-build',
    templateUrl: './misc-image-array-build.component.html',
    styleUrls: ['./misc-image-array-build.component.sass'],
  })
export class MiscImageArrayBuild implements OnInit {
  constructor(
    private clipboard: Clipboard,
    private messageService: MessageService,
    private commonEntityService: CommonEntityService,
    private buildService: BuildService,
  ) {}

  @Input() field: any;
  @Input() assetRecords: any[];

  assetRecord: any;


  get buildType(): typeof BuildType {
    return BuildType;
  }

  get assetType(): typeof AssetTypes {
    return AssetTypes;
  }

  ngOnInit(): void {
    if (!this.field || !this.assetRecords) {
      console.error('The field or asset records are not defined');
      return;
    }

    this.assetRecords.forEach(assetRecord => this.resolveBuildData(assetRecord));
  }

  /**
   * Resolves the platform to build-record-id map on assetRecord.buildData
   * into the array of build records `<build-data>` expects to render.
   */
  async resolveBuildData(assetRecord: any): Promise<void> {
    if (!assetRecord) return;
    if (!assetRecord.buildData || Array.isArray(assetRecord.buildData)) {
      assetRecord.buildData = assetRecord.buildData || [];
      return;
    }
    const response = await this.buildService.getBuildData(assetRecord.buildData);
    assetRecord.buildData = response.buildData;
    assetRecord.buildStatus = response.buildStatus;
  }

  getAssetType(assetType: number): string {
    return AssetTypes[assetType] || 'Unknown';
  }

  isUptoDate(entity: any): boolean {
    return true; 
  }

  getLastPromotedHash(entity: any): string {
    return entity?.lastPromotedHash || '';
  }

  getDynamicURL(id: string): string {
    return `/build-history/miscellaneous-build/${id}`;
  }

  openInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  /** Re-fetches one misc build after a build is queued and re-resolves its build data. */
  refreshAssetBuildData(assetRecord: any): void {
    setTimeout(async () => {
      if (!assetRecord?.id) return;
      const latest = await this.commonEntityService.findOneWithQuery('miscellaneous-build', { query: { id: assetRecord.id } });
      if (latest) {
        assetRecord.buildData = latest.buildData;
      }
      await this.resolveBuildData(assetRecord);
    }, 500);
  }

  copyPath(asset: any): void {
    const path = asset?.path || '';
    if (!path) return;
    this.clipboard.copy(path);
    this.messageService.add({ severity: 'success', summary: 'Copied', detail: 'Path copied to clipboard.' });
  }

  copyAssetInfo(asset: any): void {
    const name = asset?.name || '';
    const id = asset?.id ?? '';
    const fileName = asset?.fileName || asset?.path?.split('/').pop() || asset?.path || '';
    const text = `${name}, ID: ${id}, ${fileName}`.trim();
    if (!text || text === ', ID: ,') return;
    this.clipboard.copy(text);
    this.messageService.add({ severity: 'success', summary: 'Copied', detail: text });
  }
}
